import React from 'react';
import moment from 'moment';
import CircularIndicator from '../common/indicators/circularIndicator';

const colorCircular = risk => {
  const obj = {
    higherRisk: [],
    middleRisk: [],
    outOfRisk: []
  };
  if (risk.toUpperCase() === 'LOWRISK') {
    obj.outOfRisk.push(0, 100);
    obj.middleRisk.push(-1, -1);
    obj.higherRisk.push(-1, -1);
  } else if (risk.toUpperCase() === 'MIDDLERISK') {
    obj.outOfRisk.push(-1, -1);
    obj.middleRisk.push(0, 100);
    obj.higherRisk.push(-1, -1);
  } else if (risk.toUpperCase() === 'HIGHRISK') {
    obj.outOfRisk.push(-1, -1);
    obj.middleRisk.push(-1, -1);
    obj.higherRisk.push(0, 100);
  }

  return obj;
};

const colorSeverityItem = severety => {
  // condition to define the color as defined in the api
  if (severety == null) {
    return 'gris';
  } else if (severety.toUpperCase() === 'HIGHRISK' || severety.toUpperCase() === 'WORSE') {
    return 'red';
  } else if (severety.toUpperCase() === 'LOWRISK' || severety.toUpperCase() === 'BETTER') {
    return 'green';
  }
  return 'yellow';
};

const textTrend = (trend, val) => {
  let text;
  if (trend.toUpperCase() === 'BETTER') {
    text = `${val}% mejora respecto al período anteriror`;
  } else if (trend.toUpperCase() === 'WORSE') {
    text = `${val}% Baja respecto al período anteriror`;
  }
  return text;
};

const arrow = trend => {
  let text;
  if (trend.toUpperCase() === 'BETTER') {
    text = <i className="fas fa-arrow-up" />;
  } else if (trend.toUpperCase() === 'WORSE') {
    text = <i className="fas fa-arrow-down" />;
  }
  return text;
};

const renderCircularModalIndicators = (risk, language) => {
  if (risk.trend.toUpperCase() === 'WORSE' || risk.trend.toUpperCase() === 'BETTER') {
    return (
      <div className="circular-modal-indicators">
        <a className={colorSeverityItem(risk.trend)}>
          {arrow(risk.trend)} <h3 className={colorSeverityItem(risk.trend)}>{risk.difference}%</h3>
          <div>
            <h6 className={colorSeverityItem(risk.trend)}>
              {textTrend(risk.trend, risk.difference)}
            </h6>
            <p>
              {language.detail_fatigue.nfa.previousPeriod} (
              {moment(risk.previousValue.start).format('DD-MM')}
              {language.detail_fatigue.nfa.to} {moment(risk.previousValue.end).format('DD-MM')}){' '}
              <span className={colorSeverityItem(risk.previousValue.risk)}>
                {risk.previousValue.value}%
              </span>
            </p>
            <p>
              {language.detail_fatigue.nfa.thisPeriod} ({moment(risk.value.start).format('DD-MM')}{' '}
              {language.detail_fatigue.nfa.to} {moment(risk.value.end).format('DD-MM')}){' '}
              <span className={colorSeverityItem(risk.value.risk)}>{risk.value.value}%</span>
            </p>
          </div>
        </a>
      </div>
    );
  }
  return '';
};

const Circular = props => {
  return (
    <div className="container-circular driver sup">
      {renderCircularModalIndicators(props.inRisk, props.language)}
      <div className="circular-modal-indicators-info">
        <a className="green">
          <i className="fas fa-question-circle" />
          <div>
            <h6 className="green">{props.language.detail_fatigue.nfa.underRisk}</h6>
            <p>{props.language.detail_fatigue.nfa.driverNfa}</p>
            <p>{props.language.detail_fatigue.nfa.nfaText}</p>
            <p>
              <span className="green">NFA 1</span> {props.language.detail_fatigue.nfa.percentageOfNfaOne}
            </p>
            <p>
              <span className="yellow">NFA 2</span> {props.language.detail_fatigue.nfa.percentageOfNfaTwo}
            </p>
            <p>
              <span className="orange">NFA 3</span> {props.language.detail_fatigue.nfa.percentageOfNfaThree}
            </p>
            <p>
              <span className="red">NFA 3</span> {props.language.detail_fatigue.nfa.percentageOfNfaFour}
            </p>
          </div>
        </a>
      </div>
      <div className="circular-graph-line">
        <a>
          <div className="box-circular">
            <CircularIndicator
              size={110}
              max={100}
              value={props.inRisk.value.value}
              forceValue={100}
              fill
              id={'circle1'}
              valueFormat={{ type: 'NUMBER', format: '.0f', sufix: '%' }}
              graphColorRange={colorCircular(props.inRisk.value.risk)}
            />
          </div>
          <div className="circular-graph-line-container">
            <h6>{props.language.detail_fatigue.nfa.howItGoes}</h6>
            <div className="circular-graph-line-bar">
              <span className="text1">0%</span>
              <span className="text2">100%</span>
              <span className="text3">50%</span>
              <span style={{ left: `${props.nfa.goal}%` }} className="text4">
                85%
              </span>
              <span style={{ left: `${props.nfa.goal}%` }} className="text5">
                Meta
              </span>
              <span style={{ left: `${props.nfa.goal}%` }} className="text6" />
              <span style={{ left: `${props.currentGoalValue}%` }} className="text7">
                <i className="fas fa-truck" />
              </span>
              <div style={{ width: `${props.nfa.goalValue[0]}%` }} className="red" />
              <div style={{ width: `${props.nfa.goalValue[1]}%` }} className="yellow" />
              <div style={{ width: `${props.nfa.goalValue[2]}%` }} className="green" />
            </div>
          </div>
        </a>
      </div>
      <h3>{props.language.detail_fatigue.nfa.riskPeriod}</h3>
    </div>
  );
};
export default Circular;



// WEBPACK FOOTER //
// ./source/client/components/driver_nfa/circular.jsx